module.exports = __webpack_public_path__ + "img/source_06.6f0722fa.png";